import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import SignaturePad from 'react-signature-pad-wrapper'
import {
  API_URL,
  createPermanentContract_URL,
  showContract_URL,
  EMPLOYEES_BASE_URL,
  SHOWID_URL,
  SHOWEMPLOYEEFILE_URL

} from '../config';
import axios from 'axios';


// Config
import { POSTER_SIZE, BACKDROP_SIZE, IMAGE_BASE_URL } from '../config';
// Components
import Header from './Header';
import Thumb from './Thumb';
import Knoppie from './Knoppie';
import ClubHeader from './ClubHeader';



// Hook
import useAuth from '../hooks/useAuth';

import { useEmployeeFetch } from '../hooks/useEmployeeFetch';
// Image
import NoImage from '../images/no-image.png';
import Grid from './Grid';
import Display from './Display';
import PdfComp from './PdfComp';
import Sidepanel from './SidePanel';
import { Burger } from './SidePanel/SidePanel.styles';




const Employee = () => {



  const auth = useAuth();
  const { id } = useParams()
  const location = useLocation();
  console.log(id)
  const { state, loading, error, setLoading, setTrigger } = useEmployeeFetch(id);
  const [pdffile, setPdfFile] = useState(null)
  const [edit, setEdit] = useState(false)
  const navigate = useNavigate()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [contractsOpen, setContractsOpen] = useState(false)
  const [idOpen, setIdOpen] = useState(false)
  const [otherOpen, setOtherOpen] = useState(false)
  const [iodOpen, setIODOpen] = useState(false)
  const from = location.state?.from || './'
  const form = useForm()
  const { register, control, handleSubmit, formState } = form
  const { errors } = formState
  const [errMessage, setErrMessage] = useState("");
  const username = auth.auth.user.username
  const access = auth.auth.user.userRole
  const accessToken = auth.auth.accessToken
  // console.log(besluit.besluit[0].besluit)
  console.log(state)
  console.log(location.state)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  const handleCreateContract = async (e) => {

    console.log("create Contract gekliek")
    console.log(e.target.id)
    console.log(auth.auth.accessToken)

    const response = await axios.get(createPermanentContract_URL + "/" + e.target.id,
      {
        headers: {

          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + auth.auth.accessToken
        },
        responseType: 'blob'
      }

    );
    console.log(response)

    if (response.status !== 200) {
      throw new Error("response not ok")
    }

    console.log(response.headers)
    const contentType = response.headers.get('Content-Type')

    console.log(contentType)

    const blob = response.data;
    const url = URL.createObjectURL(blob);

    setPdfFile(url)
    setTrigger(true)

  }
  const showID = async (e) => {

    console.log("show ID gekliek")

    console.log(auth.auth.accessToken)

    const response = await axios.get(SHOWID_URL + "/" + id,
      {
        headers: {

          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + auth.auth.accessToken
        },
        responseType: 'blob'
      }

    );
    console.log(response)

    if (response.status !== 200) {
      throw new Error("response not ok")
    }

    const contentType = response.headers['content-type']; // E.g., "image/jpeg"
    console.log("Content-Type:", contentType);

    // Determine the file extension
    let extension = '';
    if (contentType === 'image/jpg') extension = '.jpg';
    else if (contentType === 'application/pdf') extension = '.pdf';
    else if (contentType === 'image/png') extension = '.png';
    else extension = ''; // Default to no extension if unknown

    const fileName = (state?.name || "downloaded-file") + extension;


    const blob = response.data;
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName; // Name of the file to be downloaded
    link.click();

  }
  const showFile = async (filename) => {

    console.log("show File gekliek")
    console.log(filename)

    console.log(auth.auth.accessToken)



    const response = await axios.get(SHOWEMPLOYEEFILE_URL + "/" + id + "/" + filename,
      {
        headers: {

          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + auth.auth.accessToken
        },
        responseType: 'blob'
      }

    );
    console.log(response)

    if (response.status !== 200) {
      throw new Error("response not ok")
    }

    const contentType = response.headers['content-type']; // E.g., "image/jpeg"
    console.log("Content-Type:", contentType);

    // Determine the file extension
    let extension = '';
    if (contentType === 'image/jpg') extension = '.jpg';
    else if (contentType === 'application/pdf') extension = '.pdf';
    else if (contentType === 'image/png') extension = '.png';
    else extension = ''; // Default to no extension if unknown

    const fileName = (state?.name || "downloaded-file") + extension;


    const blob = response.data;
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName; // Name of the file to be downloaded
    link.click();

  }

  const handleEdit = () => {
    setEdit((prev) => !prev)
  }
  const onSubmit = async (data) => {

    console.log(data)
    console.log(accessToken)

    const transformedData = {
      ...data,

      EEA1: {
        disability: data.EEA1.disability === "" ? false : data.EEA1.disability,
        foreignNational: data.EEA1.foreignNational === "" ? false : data.EEA1.foreignNational,
        gender: data.EEA1.gender,
        race: data.EEA1.race

      }
      // sdate: data.sdate
      //   ? new Date(data.sdate).toLocaleDateString('en-US', {
      //       year: 'numeric',
      //       month: 'long',
      //       day: 'numeric',
      //     })
      //   : null,
      // termdate: data.termdate
      //   ? new Date(data.termdate).toLocaleDateString('en-US', {
      //       year: 'numeric',
      //       month: 'long',
      //       day: 'numeric',
      //     })
      //   : null,

    };

    console.log(transformedData)

    try {
      const response = await axios.patch(`${EMPLOYEES_BASE_URL}/${id}`,
        JSON.stringify({ data: transformedData }),
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + accessToken

          }
        }
      );


      console.log(response)
      setEdit(false)
      setErrMessage("")
      setTrigger(true)

    } catch (error) {

      if (!error.response) {
        setErrMessage("No server response")
      } else if (error.response?.status === 400) {
        setErrMessage("Missing data")
      } else if (error.status === 500) {
        console.log(error.message)
        setErrMessage(error.message + " " + error.response?.data?.msg?.message)
      } else {
        setErrMessage('failed')
      }
      console.log(error)
    }






  }

  return (
    <>

      <Header username={username} role={access} destination={from}></Header>
      <div className='employeeBody'>


        <Sidepanel
          open={sidebarOpen}
          onClick={() => setSidebarOpen((prev) => !prev)}
        >

          <div onClick={(e) => e.stopPropagation()}>
            {/* <div onClick={() => setSidebarOpen((prev) => !prev)}>{sidebarOpen ? "Close" : "Open"}</div> */}


            <div className='DropdownContainer Contract'>
              <Knoppie
                from={`Employee/${state._id}`}
                clickable={true}
                text={"Contracts"}
                employeeid={state._id}
                callback={() => setContractsOpen((prev) => !prev)}

              />


              {contractsOpen && (
                <>
                  {state.contract?.filenames.length > 0 ? (


                    state.contract.filenames.map((filename) => (


                      <Knoppie
                        key={filename}
                        from={`Employee/${state._id}`}
                        dropdown={true}
                        clickable={true}
                        text={filename}
                        employeeid={state._id}
                        // callback={handleShowContract}
                        // pdffile={pdffile}
                        destination={`../pdfview/${state._id}/employee/${filename}`}

                      />

                    ))



                  ) : (
                    <div>No contracts on file</div>
                  )}

                  {((access === 'administrator' || access === 'manager') && auth.auth.user.employeeProfile !== id) &&

                    <Knoppie
                      from={`Employee/${state._id}`}
                      clickable={true}
                      text={"Create Contract"}
                      dropdown={true}
                      employeeid={state._id}
                      callback={handleCreateContract}

                    />
                  }

                  {(access === "administrator" || access === 'manager') && (
                    <Knoppie
                      from={`Employee/${state._id}`}
                      employeeid={state._id}
                      dropdown={true}
                      type={"Employee Contract"}
                      destination={`/Upload`}
                      text={'Upload Contract'}
                      clickable={true}
                    />
                  )}
                </>

              )}
            </div>
            <div className='DropdownContainer ID'>
              {idOpen ? (
                <>
                  <Knoppie
                    from={`Employee/${state._id}`}
                    clickable={true}
                    text={"ID"}
                    employeeid={state._id}
                    callback={() => setIdOpen((prev) => !prev)}

                  />
                  {state.IDOnFile ? (


                    <>
                      <Knoppie
                        from={`Employee/${state._id}`}
                        text={'Show ID'}
                        dropdown={true}
                        clickable={true}
                        callback={showID}
                      ></Knoppie>
                      <Knoppie
                        from={`Employee/${state._id}`}
                        employeeid={state._id}
                        type={"Employee ID"}
                        destination={`/Upload`}
                        text={'Upload new ID'}
                        dropdown={true}
                        clickable={true}
                      />
                    </>
                  ) : (
                    <Knoppie
                      from={`Employee/${state._id}`}
                      employeeid={state._id}
                      type={"Employee ID"}
                      destination={`/Upload`}
                      text={'Upload ID'}
                      dropdown={true}
                      clickable={true}
                    />
                  )}
                </>
              ) : (
                <Knoppie
                  from={`Employee/${state._id}`}
                  clickable={true}
                  text={"ID"}
                  employeeid={state._id}
                  callback={() => setIdOpen((prev) => !prev)}

                />
              )}
            </div>
            <div className='DropdownContainer Other'>


              <Knoppie
                from={`Employee/${state._id}`}
                clickable={true}
                text={"Other Documents"}
                employeeid={state._id}
                callback={() => setOtherOpen((prev) => !prev)}

              />

              {otherOpen && (
                <>
                  {state.otherDocuments?.filenames.length > 0 ? (


                    state.otherDocuments.filenames.map((filename) => (


                      <Knoppie
                        key={filename}
                        id={filename}
                        from={`Employee/${state._id}`}
                        dropdown={true}
                        clickable={true}
                        text={filename}
                        employeeid={state._id}

                        // callback={handleShowContract}
                        // pdffile={pdffile}
                        callback={() => showFile(filename)}

                      />

                    ))



                  ) : (
                    <div>No documents on file</div>
                  )}

                  {(access === "administrator" || access === 'manager') && (
                    <Knoppie
                      from={`Employee/${state._id}`}
                      employeeid={state._id}
                      dropdown={true}
                      type={"Employee Other"}
                      destination={`/Upload`}
                      text={'Upload Other Document'}
                      clickable={true}
                    />
                  )}
                </>

              )}





            </div>

            {(access === 'administrator' || access === 'manager') &&

              <div className='DropdownContainer IOD'>


                <Knoppie
                  from={`Employee/${state._id}`}
                  clickable={true}
                  text={"Injuries on Duty"}
                  employeeid={state._id}
                  callback={() => setIODOpen((prev) => !prev)}

                />

                {iodOpen && (
                  <>
                    {state.ioditems.length > 0 ? (


                      state.ioditems.map((item) => (


                        <Knoppie
                          key={item}
                          id={item}
                          from={`Employee/${state._id}`}
                          dropdown={true}
                          clickable={true}
                          text={item}
                          employeeid={state._id}
                          destination={`../Injury/${item}`}

                        />

                      ))



                    ) : (
                      <div>No Injuries recorded.</div>
                    )}

                    {(access === "administrator" || access === 'manager') && (
                      <Knoppie
                        from={`../employee/${state._id}`}
                        clickable={true}
                        text={"Record new Injury on duty"}
                        employeeid={state._id}
                        destination={`../addNewInjury/${state._id}`}

                      />
                    )}
                  </>

                )}





              </div>
            }

            {access === 'administrator' &&

              <Knoppie
                from={`Employee/${state._id}`}
                clickable={true}
                text={"Standard Payslip"}
                employeeid={state._id}
                destination={`../StandardPayslip/${state._id}`}

              />
            }

          </div>

        </Sidepanel>

        <Grid

          header={`${state.givname} ${state.surname}`}

        >



          <div >
            <img
              src={state.avatarUrl ? state.avatarUrl : NoImage}
              alt={state.name}
              className="Avatar"

              onClick={() => (
                navigate(`/upload`, { state: { id: state._id, type: "Employee Avatar" } })

              )}
            />
          </div>


          {!edit ?
            (<>
              <Knoppie
                text={"Edit profile"}
                callback={handleEdit}
              ></Knoppie>

              <Display
                key={state._id}
                employee={state.employee}
                group={state.group}

                dept={state.dept}
                title={state.title}

                givname={state.givname}
                surname={state.surname}
                adr1={state.adr1}
                adr2={state.adr2}
                adr3={state.adr3}
                pcode={state.pcode}
                phone={state.phone}
                sdate={state.sdate}
                baserate={state.baserate}
                holrule={state.holrule}
                sicrule={state.sicrule}
                holavail={state.holavail}
                leaveDates={""}
                termdate={state.termdate}
                position={state.position}
                identity={state.identity}
                incometax={state.incometax}
                dob={state.dob}
                active={state.active}
                normalHours={state.normalHours}
                gender={state.EEA1?.gender}
                race={state.EEA1?.race}
                disability={state.EEA1?.disability?.toString()}
                foreignNational={state.EEA1?.foreignNational?.toString()}
                injuryOnDuty={state.injuryOnDuty}
                IDOnFile={state.IDOnFile}
                emailaddress={state.emailaddress}

                id={state._id}
                edit={edit}

              />
            </>
            )
            :
            (<>
              <Knoppie
                text={"Cancel"}
                callback={handleEdit}
              ></Knoppie>





              {errMessage !== "" ? <div>{errMessage}</div> : ""}

              <form onSubmit={handleSubmit(onSubmit)}>
                <button>Submit</button>

                <div className='Lineitem'>
                  <label>Employee Code</label>
                  <input className="inputsize" type={"text"} defaultValue={state.employee}{...register('employee', {
                    required: 'employee code is required'
                  })} />
                </div>
                {errors.employee ? <p className='error'>{errors.employee?.message}</p> : ""}
                <div className='Lineitem'>
                  <label>Employee name</label>
                  <input className="inputsize" type={"text"} defaultValue={state.givname} {...register('givname', {
                    required: 'name is required'
                  })} />
                </div>
                {errors.givname ? <p className='error'>{errors.employee?.givname}</p> : ""}
                <div className='Lineitem'>
                  <label>Employee surname</label>
                  <input className="inputsize" type={"text"} defaultValue={state.surname}{...register('surname', {
                    required: 'surname is required'
                  })} />
                </div>
                {errors.surname ? <p className='error'>{errors.surname?.message}</p> : ""}
                <div className='Lineitem'>
                  <label>Employee group</label>
                  <input className="inputsize" type={"text"} defaultValue={state.group}{...register('group')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee dept</label>
                  <input className="inputsize" type={"text"} defaultValue={state.dept} {...register('dept')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee title</label>
                  <input className="inputsize" type={"text"} defaultValue={state.title}{...register('title')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee adr1</label>
                  <input className="inputsize" type={"text"} defaultValue={state.adr1}{...register('adr1')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee adr2</label>
                  <input className="inputsize" type={"text"} defaultValue={state.adr2}{...register('adr2')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee adr3</label>
                  <input className="inputsize" type={"text"} defaultValue={state.adr3}{...register('adr3')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee pcode</label>
                  <input className="inputsize" type={"text"} defaultValue={state.pcode}{...register('pcode')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee phone</label>
                  <input className="inputsize" type={"number"} defaultValue={state.phone}{...register('phone')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee sdate</label>
                  <input className="inputsize" type={"date"} defaultValue={state.sdate}{...register('sdate')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee baserate</label>
                  <input className="inputsize" type={"text"} defaultValue={state.baserate}{...register('baserate')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee holrule</label>
                  <input className="inputsize" type={"text"} defaultValue={state.holrule}{...register('holrule')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee sicrule</label>
                  <input className="inputsize" type={"text"} defaultValue={state.sicrule}{...register('sicrule')} />

                </div>

                <div className='Lineitem'>
                  <label>Employee termdate</label>
                  <input className="inputsize" type={"date"} defaultValue={state.termdate}{...register('termdate')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee position</label>
                  <input className="inputsize" type={"text"} defaultValue={state.position}{...register('position')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee identity</label>
                  <input className="inputsize" type={"id"} defaultValue={state.identity}{...register('identity')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee incometax</label>
                  <input className="inputsize" type={"text"} defaultValue={state.incometax}{...register('incometax')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee dob</label>
                  <input className="inputsize" type={"text"} defaultValue={state.dob}{...register('dob')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee active</label>
                  <input className="inputsize" type={"text"} value="true" {...register('active')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee gender</label>
                  <input className="inputsize" type={"text"} defaultValue={state.EEA1?.gender}{...register('EEA1.gender')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee race</label>
                  <input className="inputsize" type={"text"} defaultValue={state.EEA1?.race}{...register('EEA1.race')} />

                </div>
                <div className='Lineitem'>
                  <label>Employee disability</label>
                  <label>
                    Marked if true
                    <input
                      className="inputsize"
                      type="checkbox"
                      defaultChecked={state.EEA1?.disability || false}
                      {...register('EEA1.disability')} />
                  </label>
                </div>
                <div className='Lineitem'>
                  <label>Employee foreignNational</label>
                  <label>
                    Marked if true
                    <input
                      className="inputsize"
                      type="checkbox"
                      defaultChecked={state.EEA1?.foreignNational || false}
                      {...register('EEA1.foreignNational')} />

                  </label>
                </div>
                <div className='Lineitem'>
                  <label>Employee emailaddress</label>
                  <input className="inputsize" type={"text"} defaultValue={state.emailaddress}{...register('emailaddress', {
                    pattern: {
                      value: /^((?!\.)[\w\-_.]*[^.])(@\w+)(\.\w+(\.\w+)?[^.\W])$/gm,
                      message: "email validation failed"
                    }
                  })} />

                </div>
              </form>
            </>
            )

          }





        </Grid>
      </div>


    </>
  );
};

export default Employee;

